const DashboardTheme = {
    PrimaryBarColor: '#2B736B',
    SecondaryBarColor: '#94C21C',
    ThirdBarColor: '#F0C40D',
    FourthBarColor: '#FF8042',
    borderColor: '#ECEDEF',
    FontColor: '#AAAEB3'
};

export default DashboardTheme;